import {
  APIHubspotFoodPartnerWithContacts,
  HubspotFoodPartner,
  HubspotContact,
} from '@types'

interface CheckFoodPartnerLinkedCoordinator {
  RestService: {
    get: (url: string) => Promise<{ isLinked: boolean }>
  }
  HandleError: any
}
export const CheckFoodPartnerLinked =
  ({ RestService, HandleError }: CheckFoodPartnerLinkedCoordinator) =>
  async (id: string): Promise<boolean> => {
    try {
      const resp = await RestService.get(
        `/hubspot/food-partners/${id}/check-link`,
      )

      return resp.isLinked
    } catch (error) {
      HandleError({ error })

      return false
    }
  }

interface GetHubspotFoodPartnerCoordinator {
  RestService: {
    get: (url: string) => Promise<APIHubspotFoodPartnerWithContacts>
  }
  pResponseHubspotFoodPartnerWithContacts: (
    resp: APIHubspotFoodPartnerWithContacts,
  ) => { foodPartner: HubspotFoodPartner; contacts: HubspotContact[] }
  HandleError: any
}
export const GetHubspotFoodPartner =
  ({
    RestService,
    pResponseHubspotFoodPartnerWithContacts,
    HandleError,
  }: GetHubspotFoodPartnerCoordinator) =>
  async (id: string) => {
    if (id === '') {
      return null
    }

    try {
      const resp = await RestService.get(`/hubspot/food-partners/${id}/search`)

      return pResponseHubspotFoodPartnerWithContacts(resp)
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

interface NewChefFromHubspotCoordinator {
  ChefService: {
    getState: () => any
    clearChef: () => void
    setEditChef: () => void
    setChef: (data: any) => void
  }
  UIService: {
    EditChef: {
      show: () => void
      close: () => void
      closeFoodPartnerModal: () => void
    }
  }
  createChefFromHubspot: (
    foodPartner: HubspotFoodPartner,
    contacts: HubspotContact[] | null,
    hqId: number,
  ) => any
}
export const NewChefFromHubspot =
  ({
    ChefService,
    UIService,
    createChefFromHubspot,
  }: NewChefFromHubspotCoordinator) =>
  (
    foodPartner: HubspotFoodPartner,
    contacts: HubspotContact[] | null,
    hqId: number,
  ) => {
    ChefService.clearChef()
    UIService.EditChef.closeFoodPartnerModal()
    const { chef: baseChef } = ChefService.getState()
    ChefService.setChef({
      ...baseChef,
      ...createChefFromHubspot(foodPartner, contacts, hqId),
    })
    ChefService.setEditChef()
    UIService.EditChef.show()
  }

type ImportExistingChefCoordinator = {
  ChefService: {
    getState: () => any
    clearChef: () => void
    setEditChef: () => void
    setChef: (data: any) => void
  }
  UIService: {
    EditChef: {
      show: () => void
      close: () => void
      closeFoodPartnerModal: () => void
    }
  }
  RestService: {
    get: (id: string) => Promise<any>
  }
  pResponseChef: any
  HandleError: any
}
export const ImportExistingChef =
  ({
    RestService,
    ChefService,
    UIService,
    pResponseChef,
    HandleError,
  }: ImportExistingChefCoordinator) =>
  async (chefId: string) => {
    try {
      let chef = await RestService.get(`/api/admin/chefs/${chefId}`)
      chef = pResponseChef(chef)

      ChefService.clearChef()
      UIService.EditChef.closeFoodPartnerModal()
      const { chef: baseChef } = ChefService.getState()
      ChefService.setChef({
        ...baseChef,
        ...chef,
      })
      ChefService.setEditChef()
      UIService.EditChef.show()
    } catch (error) {
      HandleError({ error })
    }
  }
